





























import Header from '@/components/Header.vue';
import VideoActions from '@/components/VideoActions.vue';
import { Video } from '@/types/Video';
import Vue from 'vue';
import 'vuex';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'Projects',
    components: {
        Header,
        VideoActions,
    },
    data: () => ({
        tab: null,
    }),
    computed: {
        ...mapGetters(['unfinishedVideos']),
    },
    methods: {
        goToProject(video: Video) {
            this.$router.push(`/projects/${video.id}`);
        },
    },
});
